import { Attributes } from "@opentelemetry/api";

const normalizeAttributeValue = (
  value: unknown,
): string | number | boolean | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return value;
  }

  if (Array.isArray(value)) {
    const filtered = value.filter((item) => item !== undefined && item !== null);
    if (!filtered.length) {
      return undefined;
    }
    try {
      return JSON.stringify(filtered);
    } catch {
      return undefined;
    }
  }

  if (typeof value === "object") {
    try {
      return JSON.stringify(value);
    } catch {
      return undefined;
    }
  }

  try {
    return String(value);
  } catch {
    return undefined;
  }
};

export const sanitizeAttributes = (
  attributes: Record<string, unknown> = {},
): Attributes => {
  const sanitized: Record<string, string | number | boolean> = {};

  Object.entries(attributes).forEach(([key, value]) => {
    if (!key) {
      return;
    }

    const normalized = normalizeAttributeValue(value);
    if (normalized !== undefined) {
      sanitized[key] = normalized;
    }
  });

  return sanitized;
};
